<header class="flex-row-center gap-5 px-4 py-2 border border-b-gray-200">
  <div class="cursor-pointer" [routerLink]="AppUrls.Dashboard.absoluteUrl">
    <app-logo [priority]="true" />
  </div>

  <app-company-switcher />

  <div class="flex-1"></div>

  <app-user-menu />
</header>
